import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// One name + description modal per page for course templates (TMS-1585): "Save as
// template" on the Courses index and "Edit details" on the Templates tab. The row's
// trigger says where the form posts and what to prefill, the same way
// duplicate_course_modal_controller points its modal at the clicked course.
export default class extends Controller {
  static targets = ["modal", "form", "courseTitle", "nameInput", "descriptionInput"];
  static values = {
    baseUrl: String
  };

  open(event) {
    event.preventDefault();

    const { courseId, courseTitle, url, name, description } = event.currentTarget.dataset;

    this.formTarget.action = url || this.baseUrlValue.replace(":id", courseId);
    if (this.hasCourseTitleTarget) this.courseTitleTarget.textContent = courseTitle || "";
    this.nameInputTarget.value = name ?? courseTitle ?? "";
    if (this.hasDescriptionInputTarget) this.descriptionInputTarget.value = description || "";

    Modal.getOrCreateInstance(this.modalTarget).show();

    this.modalTarget.addEventListener("shown.bs.modal", () => {
      this.nameInputTarget.focus();
      this.nameInputTarget.select();
    }, { once: true });
  }
}
